var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatched(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 13,
    viewBox: "0 0 24 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.16919H18C18.6566 1.16919 19.3068 1.29852 19.9134 1.54979C20.52 1.80107 21.0712 2.16936 21.5355 2.63366C21.9998 3.09795 22.3681 3.64914 22.6194 4.25577C22.8707 4.8624 23 5.51258 23 6.16919C23 6.8258 22.8707 7.47598 22.6194 8.08261C22.3681 8.68923 21.9998 9.24043 21.5355 9.70472C21.0712 10.169 20.52 10.5373 19.9134 10.7886C19.3068 11.0399 18.6566 11.1692 18 11.1692H15M9 11.1692H6C5.34339 11.1692 4.69321 11.0399 4.08658 10.7886C3.47995 10.5373 2.92876 10.169 2.46447 9.70472C1.52678 8.76704 1 7.49527 1 6.16919C1 4.84311 1.52678 3.57134 2.46447 2.63366C3.40215 1.69597 4.67392 1.16919 6 1.16919H9M8 6.16919H16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatched);
export default __webpack_public_path__ + "static/media/matched.54915895.svg";
export { ForwardRef as ReactComponent };